<template>
  <div :id="currentPage" class="base-page page">
    <slot />
    <div class="footer">
      <div class="focus" :class="{ show: filters }">{{ $t('focusStudyOn') }} : {{ filters }}</div>
      <div class="right-container">
        <div class="logo-line">
          <div class="jll-logo"></div>
          <div class="divider-vertical"></div>
          <div class="commuter-logo">Commuter</div>
        </div>
        <div class="page-number">
          {{ currentPage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BasePage',

  props: {
    study: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    export: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    filters: {
      type: String,
      required: false,
      default: null,
    },

    isIndex: {
      type: Boolean,
      required: false,
      default: false,
    },

    disableCount: {
      type: [Boolean, Number],
      required: false,
      default: false,
    },
  },

  data() {
    return {
      currentPage: 0,
    };
  },

  computed: {
    ...mapGetters({
      totalPages: 'totalPages',
    }),
  },

  mounted() {
    if (!this.disableCount) {
      this.currentPage = Number(this.totalPages + 1);
      this.$store.dispatch('setPage');
    } else {
      this.currentPage = this.disableCount;
    }
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';

.base-page {
  position: relative;
  flex: 1;
  overflow: hidden;

  .footer {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    color: #9b9b9b;
    padding: 16px 24px 16px 64px;
    font-size: 0.8em;

    .focus {
      opacity: 0;

      &.show {
        opacity: 1;
      }
    }

    .right-container {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .logo-line {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .jll-logo {
          width: 64px;
          height: 24px;
          margin: 0;

          background-image: url('./../../assets/JLLLogo-Color.png');
          background-repeat: no-repeat;
          background-position: center right;
          background-size: cover;
        }

        .divider-vertical {
          width: 1px;
          height: 16px;
          border-radius: 2px;
          margin: 2px 16px -2px 12px;
          background: #9b9b9b;
        }

        .commuter-logo {
          font-size: 20px;
          color: colors.$stone-color;
          font-family: 'Golden Plains';
        }
      }
    }

    .page-number {
      text-align: right;
      width: 32px;
      color: #3c3c3b;
    }
  }
}
</style>
